
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-we-feed-raw",
      function () {
        return require("private-next-pages/why-we-feed-raw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-we-feed-raw"])
      });
    }
  